import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import cleave from 'vue-cleave-component';
//fa
import {library} from '@fortawesome/fontawesome-svg-core'
import { faFontAwesome, fab} from '@fortawesome/free-brands-svg-icons'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText} from '@fortawesome/vue-fontawesome'

//owms components
import Loader from '@/owms/components/loader/Loader.vue'
import BooleanCheckbox from '@/owms/components/checkbox/BooleanCheckbox';
import TextInput from '@/owms/components/input/TextInput';
import TextAreaInput from '@/owms/components/input/TextAreaInput';
import NumberInput from '@/owms/components/input/NumberInput';
import ValueSelect from '@/owms/components/select/ValueSelect';
import DateSelect from '@/owms/components/date/DateSelect';
import TimeSelect from '@/owms/components/date/TimeSelect';
import BaseTable from '@/owms/components/table/BaseTable';
import BaseForm from '@/owms/components/form/BaseForm';
import AutocompletePlaces from '@/owms/components/google/AutocompletePlaces';
import Cropper from '@/owms/components/image/Cropper';
import Preview from '@/owms/components/file/Preview';
import PasswordInput from "@/owms/components/input/PasswordInput";
import PreviewClient from "@/owms/components/file/PreviewClient";


Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component('cleave', cleave);
//fa
library.add(faFontAwesome)
library.add(fas, fab);
//add custom fa icons
/** @type {import('@fortawesome/fontawesome-svg-core').IconDefinition} */
const faGo = {
    prefix: 'fas',
    iconName: 'ozs-go',
    icon: [
        256,
        256,
        [],
        'e900',
        [
            'M160.531 107.75c-12.23 3.105 -20.578 5.438 -32.617 8.543 -2.914 0.777 -3.105 0.973 -5.625 -1.941 -2.914 -3.301 -5.047 -5.438 -9.125 -7.375 -12.23 -6.02 -24.074 -4.27 -35.141 2.914 -13.203 8.543 -20 21.16 -19.801 36.887 0.195 15.531 10.875 28.344 26.211 30.48 13.203 1.75 24.266 -2.914 33 -12.813 1.75 -2.137 3.301 -4.465 5.242 -7.184h-37.473c-4.078 0 -5.047 -2.523 -3.688 -5.824 2.523 -6.02 7.184 -16.113 9.902 -21.16a5.234 5.234 0 0 1 4.855 -3.105h70.668c-0.391 5.242 -0.391 10.484 -1.164 15.727a82.813 82.813 0 0 1 -15.922 38.051c-13.98 18.441 -32.23 29.895 -55.332 33 -19.027 2.523 -36.695 -1.164 -52.227 -12.813a61.016 61.016 0 0 1 -24.656 -43.102C15.117 136.875 21.328 117.848 34.141 101.148c13.785 -18.055 32.035 -29.508 54.359 -33.586 18.25 -3.301 35.723 -1.164 51.449 9.512a60.938 60.938 0 0 1 22.52 27.375c1.168 1.746 0.391 2.719 -1.938 3.301',
            'M224.793 215.113c-17.668 -0.391 -33.781 -5.438 -47.375 -17.086a60.859 60.859 0 0 1 -20.969 -37.469c-3.5 -21.938 2.523 -41.352 15.727 -58.633 14.172 -18.637 31.258 -28.344 54.359 -32.422 19.801 -3.5 38.441 -1.555 55.332 9.902 15.336 10.484 24.852 24.656 27.375 43.293 3.301 26.211 -4.27 47.566 -22.328 65.816a88.945 88.945 0 0 1 -46.594 24.852c-5.238 0.973 -10.48 1.168 -15.527 1.75m46.207 -78.434a54.688 54.688 0 0 0 -0.582 -6.406c-3.5 -19.219 -21.16 -30.094 -39.605 -25.82 -18.055 4.078 -29.703 15.531 -33.977 33.781a31.977 31.977 0 0 0 17.859 36.695c10.676 4.66 21.355 4.078 31.645 -1.164 15.336 -7.961 23.684 -20.387 24.656 -37.082'
        ].join(' ')
    ]
}
library.add(faGo)

Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.component('font-awesome-layers-text', FontAwesomeLayersText);

//owms components
Vue.component('custom-loader', Loader)
Vue.component('boolean-checkbox', BooleanCheckbox);
Vue.component('password-input', PasswordInput);
Vue.component('text-input', TextInput);
Vue.component('text-area-input', TextAreaInput);
Vue.component('number-input', NumberInput);
Vue.component('value-select', ValueSelect);
Vue.component('date-select', DateSelect);
Vue.component('time-select', TimeSelect);
Vue.component('base-table', BaseTable);
Vue.component('base-form', BaseForm);
Vue.component('google-autocomplete-places', AutocompletePlaces);
Vue.component('image-cropper', Cropper);
Vue.component('file-preview', Preview);
Vue.component('file-preview-client', PreviewClient);
